import React, { useState } from "react";

export const AddMoviesForm = ({ userData, setUserData }) => {
	const [currentMovies, setCurrentMovies] = useState("");

	// Handle adding movies
	const addMovies = () => {
		if (currentMovies && !userData?.movies?.includes(currentMovies)) {
			const updatedMovies = userData?.movies ? [...userData?.movies, currentMovies] : [currentMovies];
			if (updatedMovies.length > 5) {
				updatedMovies.pop(); // Remove the last movies if there are more than 5
			}
			const updatedUserData = { ...userData, movies: updatedMovies };
			setUserData(updatedUserData);
			setCurrentMovies(""); // Reset input
		}
	};

	// Handle removing a movies
	const removeMovies = (moviesName) => {
		const updatedMovies = userData?.movies?.filter((h) => h !== moviesName);
		const updatedUserData = { ...userData, movies: updatedMovies };
		setUserData(updatedUserData);
	};

	return (
		<>
			<label htmlFor="movies" className="form-label">
				<i className="bi bi-film"></i> <span>TV / Film</span>
			</label>
			<div className="input-group mb-2">
				<input
					className="form-control"
					value={currentMovies}
					onChange={(e) => setCurrentMovies(e.target.value)}
					maxLength={50}
					placeholder="Type TV series/film you've enjoyed..."
				/>
				<button
					className="btn my-btn d-flex align-items-center justify-content-center"
					onClick={addMovies}
					disabled={!currentMovies || userData?.movies?.length >= 5}
					style={{ padding: "0", height: "38px", width: "78px" }}
				>
					<i className="bi bi-plus" style={{ fontSize: "38px" }}></i>
				</button>
			</div>

			<div>
				<ul className="list-group">
					{userData?.movies?.map((movie, index) => (
						<li
							key={index}
							className="list-group-item d-flex justify-content-between align-items-center"
							style={{ padding: "0 0 0 10px" }}
						>
							<div>
								<i className="bi bi-film me-2"></i>
								{movie}
							</div>
							<button
								className="btn btn-danger btn-sm"
								onClick={() => removeMovies(movie)}
								style={{ padding: "0", height: "30px", width: "30px" }}
							>
								<i className="bi bi-trash"></i>
							</button>
						</li>
					))}
				</ul>
			</div>
		</>
	);
};
